import { useState } from "react";
import { X } from "lucide-react";

const GALLERY_ITEMS = [
  { src: "/assets/hero-bg-6.jpeg", title: "The Throne of Fire" },
  { src: "/assets/hero-bg-1.jpeg", title: "Crimson Gaze" },
  { src: "/assets/hero-bg-3.jpeg", title: "The Dark Knight" },
  { src: "/assets/hero-bg-8.jpeg", title: "Lunar Conquest" },
  { src: "/assets/hero-bg-2.jpeg", title: "Inferno Rising" },
  { src: "/assets/hero-bg-7.jpeg", title: "The Zodiac Forge" },
  { src: "/assets/hero-bg-5.jpeg", title: "Flame Bearer" },
  { src: "/assets/hero-bg-4.jpeg", title: "Cathedral of Ash" },
];

export const ArtGallery = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section data-testid="art-gallery" className="relative w-full py-20 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fire-red/30 to-transparent" />

      <div className="px-4 sm:px-6 md:px-12 lg:px-20 mb-8 sm:mb-10">
        <p className="font-mono text-[10px] text-fire-ember/60 uppercase tracking-[0.3em] mb-2">Collection</p>
        <h2 data-testid="gallery-title" className="font-cinzel text-xl sm:text-2xl md:text-3xl font-bold uppercase tracking-[0.1em] sm:tracking-[0.15em] text-foreground">
          Gallery of the Fire Horse
        </h2>
      </div>

      {/* Horizontal scroll gallery */}
      <div className="relative">
        <div className="flex gap-3 sm:gap-4 px-4 sm:px-6 md:px-12 lg:px-20 overflow-x-auto pb-6 gallery-scroll">
          {GALLERY_ITEMS.map((item, i) => (
            <button
              key={i}
              data-testid={`gallery-item-${i}`}
              onClick={() => setLightbox(i)}
              className="flex-shrink-0 group relative overflow-hidden cursor-pointer border-0 p-0 bg-transparent"
              style={{ borderRadius: "2px" }}
            >
              <div className="w-48 h-64 sm:w-64 sm:h-80 md:w-72 md:h-96 overflow-hidden" style={{ borderRadius: "2px" }}>
                <img
                  src={item.src}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4" style={{ borderRadius: "2px" }}>
                <p className="font-cinzel text-sm font-bold text-white uppercase tracking-wider">{item.title}</p>
              </div>
              <div className="absolute inset-0 border border-transparent group-hover:border-fire-red/40 transition-colors duration-300" style={{ borderRadius: "2px" }} />
            </button>
          ))}
        </div>

        {/* Fade edges */}
        <div className="absolute top-0 left-0 bottom-6 w-12 bg-gradient-to-r from-[#050404] to-transparent pointer-events-none z-10" />
        <div className="absolute top-0 right-0 bottom-6 w-12 bg-gradient-to-l from-[#050404] to-transparent pointer-events-none z-10" />
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-md"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 text-white/60 hover:text-white transition-colors bg-transparent border-0 cursor-pointer z-10"
            data-testid="lightbox-close"
          >
            <X className="w-8 h-8" />
          </button>
          <div className="relative max-w-4xl max-h-[85vh] mx-4" onClick={(e) => e.stopPropagation()}>
            <img
              src={GALLERY_ITEMS[lightbox].src}
              alt={GALLERY_ITEMS[lightbox].title}
              className="max-w-full max-h-[80vh] object-contain"
              style={{ borderRadius: "2px" }}
            />
            <p className="text-center mt-4 font-cinzel text-lg font-bold text-foreground uppercase tracking-wider">
              {GALLERY_ITEMS[lightbox].title}
            </p>
          </div>
          {/* Nav arrows */}
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white text-4xl font-mono bg-transparent border-0 cursor-pointer"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + GALLERY_ITEMS.length) % GALLERY_ITEMS.length); }}
            data-testid="lightbox-prev"
          >
            &lsaquo;
          </button>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white text-4xl font-mono bg-transparent border-0 cursor-pointer"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % GALLERY_ITEMS.length); }}
            data-testid="lightbox-next"
          >
            &rsaquo;
          </button>
        </div>
      )}

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fire-red/30 to-transparent" />
    </section>
  );
};
